import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../siteConfig";
import Reveal from "./Reveal";

const { colors, serviceAreas } = siteConfig;

/*
  area: optional override for which city the map centers on
  (used on /service-areas/:areaSlug pages to show that specific city).
  Defaults to the first city in siteConfig.serviceAreas everywhere else.
*/
const ServiceAreasStrip = ({ area }) => {
  const mapArea = area || serviceAreas[0];
  const mapEmbedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(
    `${mapArea}, ${siteConfig.state}`
  )}&output=embed`;

  return (
  <section style={{ backgroundColor: colors.dark }}>
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20">
      <div className="grid lg:grid-cols-2 gap-10 items-center">

        {/* Left — map */}
        <Reveal as="div" className="rounded-2xl overflow-hidden shadow-lg" style={{ height: "420px" }}>
          <iframe
            src={mapEmbedUrl}
            title={`Map of ${mapArea}, ${siteConfig.state}`}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          />
        </Reveal>

        {/* Right — heading + area grid */}
        <Reveal as="div" animation="right">
          <h2
            className="font-display font-black uppercase leading-tight mb-8 text-white"
            style={{ fontSize: "clamp(2rem,4vw,3.25rem)" }}
          >
            Proudly Serving<br />These Areas
          </h2>

          <div className="grid grid-cols-2 gap-x-8 gap-y-3">
            {serviceAreas.map((area) => (
              <Link
                key={area}
                to={`/service-areas/${area.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-bold text-base transition-colors hover:underline"
                style={{ color: colors.primary }}
              >
                {area}
              </Link>
            ))}
          </div>
        </Reveal>

      </div>
    </div>
  </section>
  );
};

export default ServiceAreasStrip;
